import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [token, setToken] = useState(localStorage.getItem("vt_token"));

  const loadMe = useCallback(async () => {
    if (!localStorage.getItem("vt_token")) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("vt_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("vt_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, acceptTerms, phone) => {
    const { data } = await api.post("/auth/register", { name, email, password, accept_terms: acceptTerms, phone });
    localStorage.setItem("vt_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("vt_token");
    setToken(null);
    setUser(false);
  };

  const refreshUser = loadMe;

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout, refreshUser, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
